// TODO: Replace 'react-bootstrap-daterangepicker' with a maintained alternative.
// This library is outdated and lacks proper TypeScript support. Temporary type override below.
import * as DateRangePickerLib from 'react-bootstrap-daterangepicker';
const DateRangePicker = DateRangePickerLib.default as unknown as React.FC<any>;

import React from 'react';
import { TextOnly } from './Text';
import { calculateStartAndEndDate } from '../libs/utils';

export type DateRangeOptions =
  | 'Today'
  | 'yesterday'
  | 'last30Days'
  | 'thisMonth'
  | 'lastMonth'
  | 'last365days'
  | 'last3years'
  | 'thisYear'
  | 'lastYear'

type CustomDatePickerProps = {
  rangePicked: DateRangeOptions;
  setRangePicked: Function;
};

export const rangeOptions = {
  Today: TextOnly('Today'),
  yesterday: TextOnly('yesterday'),
  last30Days: TextOnly('last30Days'),
  thisMonth: TextOnly('thisMonth'),
  lastMonth: TextOnly('lastMonth'),
  last365days: TextOnly('last365days'),
  last3years: TextOnly('last3years'),
  thisYear: TextOnly('thisYear'),
  lastYear: TextOnly('lastYear'),
};

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  rangePicked,
  setRangePicked,
}) => {

  const locale = {
    language: TextOnly('hl'),
    format: 'YYYY-MM-DD',
    separator: ' - ',
    applyLabel: TextOnly('apply'),
    cancelLabel: TextOnly('cancel'),
    monthNames: [
      TextOnly('January'),
      TextOnly('February'),
      TextOnly('March'),
      TextOnly('April'),
      TextOnly('May'),
      TextOnly('June'),
      TextOnly('July'),
      TextOnly('August'),
      TextOnly('September'),
      TextOnly('October'),
      TextOnly('November'),
      TextOnly('December'),
    ],
    daysOfWeek: [
      TextOnly('Sun'),
      TextOnly('Mon'),
      TextOnly('Tue'),
      TextOnly('Wed'),
      TextOnly('Thu'),
      TextOnly('Fri'),
      TextOnly('Sat'),
    ],
  };

  const defaultDate = calculateStartAndEndDate(rangePicked);
  const startDate = defaultDate.startDateStr.split('T')[0];
  const endDate = defaultDate.endDateStr.split('T')[0];
  return (
    <div className="display-flex">
      <div className="c-select u-margin-right">
        <select
          value={rangePicked}
          onChange={(event) => setRangePicked(event.target.value)}
        >
          {Object.keys(rangeOptions).map((range) => (
            <option key={range} value={range}>
              {rangeOptions[range]}
            </option>
          ))}
          <option value={`${startDate}&&${endDate}`}>
            {TextOnly('custom')}
          </option>
        </select>
      </div>
      {!rangeOptions[rangePicked]  && (
        <DateRangePicker
          useCurrent={false}
          initialSettings={{
            startDate: startDate,
            endDate: endDate,
            locale,
            containerClass: 'width-100',
            showDropdowns: true,
            alwaysShowCalendars: true,
            timePicker: false,
            drops: 'down',
            showCustomRangeLabel: false,
          }}
          onApply={(event, dateRangePicker) => {
            const { startDate, endDate } = dateRangePicker;
            setRangePicked(`${startDate.format('YYYY-MM-DD')}&&${endDate.format('YYYY-MM-DD')}`)
          }}
        >
          <div className={`Bootstrap__dateRangePicker u-margin-bottom-none`}>
            <span>{startDate}</span> <i className="fal fa-arrow-right"></i>{' '}
            <span>{endDate}</span>{' '}
          </div>
        </DateRangePicker>
      )}
    </div>
  );
};

export default CustomDatePicker;
